// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const TagTypeIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M16.28 1.5h3.55c1.48 0 2.67 1.2 2.67 2.69v3.58c0 1.49-1.2 2.7-2.67 2.7h-3.55c-1.47 0-2.67-1.21-2.67-2.7V4.2c0-1.49 1.2-2.69 2.67-2.69"
        opacity=".5"
      />
      <path d="M7.72 13.54c1.47 0 2.67 1.2 2.67 2.69v3.58c0 1.49-1.2 2.69-2.67 2.69H4.17c-1.48 0-2.67-1.2-2.67-2.69v-3.58c0-1.49 1.2-2.7 2.67-2.7zm12.11 0c1.48 0 2.67 1.2 2.67 2.69v3.58c0 1.49-1.2 2.69-2.67 2.69h-3.55c-1.47 0-2.67-1.2-2.67-2.69v-3.58c0-1.49 1.2-2.7 2.67-2.7zM7.73 1.5c1.46 0 2.66 1.2 2.66 2.69v3.58c0 1.49-1.2 2.7-2.67 2.7H4.17c-1.48 0-2.67-1.21-2.67-2.7V4.2c0-1.5 1.2-2.7 2.67-2.7z" />
    </g>
  </SvgIcon>
);

export default TagTypeIcon;
